module.exports = __webpack_public_path__ + "static/img/turtle_cat-and-mouse.b2621d5.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/assignments/python/images/turtle_cat-and-mouse.png
// module id = sdB1
// module chunks = 1